import { CharField, RadiosField } from "@inmagik/magik-ui"
import { getIn, useFormikContext } from "formik"
import { Col } from "react-bootstrap"
import { Tag } from "../../types"

export default function TagForm({ col = 8 }: { col?: number }) {
  const { setFieldValue, values, errors, submitCount } = useFormikContext<Tag>()

  return (
    <Col xs={col} className="d-flex flex-column align-items-stretch gap-4">
      <CharField
        label="Nome"
        layout="horizontal"
        value={values.nome}
        onChange={(value) => {
          setFieldValue("nome", value)
        }}
        isValid={submitCount > 0 ? !getIn(errors, "nome") : undefined}
        errorMessage={getIn(errors, "nome")}
        required
      />
      <RadiosField
        label="Tipologia"
        layout="horizontal"
        value={values.tipologia}
        onChange={(value) => {
          setFieldValue("tipologia", value)
        }}
        options={[
          { label: "Personajes", value: "Personajes" },
          { label: "Objectos", value: "Objectos" },
          { label: "Lugares", value: "Lugares" },
          { label: "Animales", value: "Animales" },
        ]}
        isValid={submitCount > 0 ? !getIn(errors, "tipologia") : undefined}
        errorMessage={getIn(errors, "tipologia")}
        required
      />
    </Col>
  )
}
